import { createLucideIcon } from "lucide-react-native";

/**
 * Custom composite filter-chip icons: an egg and a sperm, each with a small
 * "freeze" star in the top-right corner, for the Egg Freezing / Sperm Freezing
 * quick filters on Find care.
 *
 * Built with `createLucideIcon` so they behave exactly like a Lucide icon: the
 * chip injects a single stroke `color` (which applies to every path here) and
 * the same `size` / `strokeWidth`, so they match the other chip icons. The
 * array is passed inline so it is contextually typed against lucide's
 * `IconNode` (every attribute value must be a string).
 */

// 6-point snow star centered around the top-right (17.5, 6).
const FREEZE_STAR = "M14.3 6h6.4";

export const EggFreezingIcon = createLucideIcon("EggFreezing", [
  [
    "path",
    {
      d: "M9 7C5 7 3.5 11 3.5 14.75 3.5 18.2 6 20.5 9 20.5 12 20.5 14.5 18.2 14.5 14.75 14.5 11 13 7 9 7Z",
      key: "egg",
    },
  ],
  ["path", { d: FREEZE_STAR, key: "fs1" }],
  ["path", { d: "M15.9 3.23 19.1 8.77", key: "fs2" }],
  ["path", { d: "M19.1 3.23 15.9 8.77", key: "fs3" }],
]);

export const SpermFreezingIcon = createLucideIcon("SpermFreezing", [
  ["circle", { cx: "7.5", cy: "16", r: "2.8", key: "head" }],
  [
    "path",
    {
      d: "M10.2 15 C12.5 14 11 11.5 13 10.5 C15 9.5 13.5 8 15.8 7",
      key: "tail",
    },
  ],
  ["path", { d: "M15.7 4.8h4.6", key: "sf1" }],
  ["path", { d: "M16.85 2.81 19.15 6.79", key: "sf2" }],
  ["path", { d: "M19.15 2.81 16.85 6.79", key: "sf3" }],
]);
